import { render, staticRenderFns } from "./TestFunctions.vue?vue&type=template&id=f138dc4a&scoped=true&"
import script from "./TestFunctions.vue?vue&type=script&lang=js&"
export * from "./TestFunctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138dc4a",
  null
  
)

export default component.exports